import { DATAFLOW_NAV_PATHS, MILKYWAY_NAV_PATHS } from '../../constants/navigation'

export type LegacyAppMode = 'milkyway' | 'platform' | 'dataflow'

export interface LegacyRedirect {
  path: string
  state?: { openFirstGlobe: true }
}

function pathIsIn(pathname: string, paths: readonly string[]): boolean {
  return paths.some((path) => pathname === path || pathname.startsWith(`${path}/`))
}

/**
 * Where to send the user when entering a legacy mode from a page that mode
 * does not show. Null means stay on the current URL. Behaviour matches the
 * previous switchMode body.
 */
export function legacyRedirectTarget(mode: LegacyAppMode, pathname: string): LegacyRedirect | null {
  if (mode === 'milkyway') {
    return pathIsIn(pathname, MILKYWAY_NAV_PATHS) ? null : { path: '/ideate' }
  }
  if (mode === 'dataflow') {
    return pathIsIn(pathname, DATAFLOW_NAV_PATHS)
      ? null
      : { path: '/ontology/migrations', state: { openFirstGlobe: true } }
  }
  const leavesIdeate =
    pathname === '/ideate' ||
    pathname.startsWith('/ideate/') ||
    pathname === '/parallelx' ||
    pathname.startsWith('/parallelx/')
  return leavesIdeate ? { path: '/' } : null
}
